import { Component, OnInit } from '@angular/core';
import { MensagemService, ProgressoService, Restricao, RestricaoOperador, Restricoes } from 'maestro-ng';
import { Pais } from '../pais.model';
import { PaisService } from '../pais.service';
import { DataSourceRouted } from '../../util/data-source-routed';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-pais-lista',
  templateUrl: './pais-lista.component.html',
  styleUrls: ['./pais-lista.component.css'],
})
export class PaisListaComponent implements OnInit {
  public ds: DataSourceRouted<Pais, number>;

  constructor(
    private service: PaisService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ds = new DataSourceRouted<Pais, number>(
      'administracao-pais',
      (c) => this.service.recuperarPaginado(c),
      this.mensagemService,
      this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes([
        new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
        new Restricao<string>({ atributo: 'nome', operador: RestricaoOperador.CONTAINS }),
        new Restricao<string>({ atributo: 'sigla', operador: RestricaoOperador.EQUALS }),
      ])
    );
  }

  ngOnInit(): void {}
}
